import { enhancedApi } from '@store/generated/referrals';

/**
 * Feature-specific tag types for referrals cache management
 */
const REFERRAL_TAG_TYPES = ['Referral', 'ReferralDashboard'] as const;

/**
 * Referrals API - extends the generated OpenAPI client
 * This ensures we're using generated types and endpoints
 * while maintaining feature-specific customization
 */
export const referralsApi = enhancedApi.enhanceEndpoints({
  addTagTypes: REFERRAL_TAG_TYPES,
  endpoints: {
    // Enhance generated endpoint with cache tags
    getV2ProviderReferrals: {
      providesTags: result =>
        result
          ? [
              { type: 'ReferralDashboard' as const, id: 'DASHBOARD' },
              ...(result.referrals || []).map((_, index) => ({
                type: 'Referral' as const,
                id: index.toString(),
              })),
            ]
          : [{ type: 'ReferralDashboard', id: 'DASHBOARD' }],
    },
  },
});

// Export ONLY user-friendly names (never export verbose names)
export const { useGetV2ProviderReferralsQuery: useReferralsQuery } = referralsApi;
